module.exports = __webpack_public_path__ + "static/shapes2-f2e487b02ca9d7c81a334fd01ac45ee1.png";